export const PERSONAL_DETAILS_FORM_CONFIGURATION = [
  {
    id: 'firstName',
    label: 'firstName',
    type: 'text'
  },
  {
    id: 'lastName',
    label: 'lastName',
    type: 'text'
  },
  {
    id: 'email',
    label: 'email',
    type: 'email'
  }
];

export type PersonalDetailsType = {
  firstName: string;
  lastName: string;
  email: string;
};
